export const host = 'https://panel.logikon.eu/';
export const endpoint = 'https://panel.logikon.eu//dbCall.php';
export const panelUrl = '/panel';